package fr.frux.feature.premium

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [PremiumViewModel], honoré par le composition root (#43). */
fun interface PremiumViewModelFactory {
    fun create(): PremiumViewModel
}

/** Fabrique installée par le composition root, sans défaut : l'oubli de câblage doit crier. */
val LocalPremiumViewModelFactory =
    staticCompositionLocalOf<PremiumViewModelFactory> {
        error("PremiumViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
    }

@Composable
fun rememberPremiumViewModel(): PremiumViewModel {
    val factory = LocalPremiumViewModelFactory.current
    return viewModel { factory.create() }
}
